export default "__VITE_ASSET__BMpnr1wS__"